define('viewModels/privileged/qm/InteractionsListView',[
    'lib/lodash4',
    'lib/knockout',
    'lib/bluebird',
    'services/queuesService',
    'viewModels/ViewModel',
    'viewModels/privileged/qm/ConversationDetailsView',
    'viewModels/privileged/qm/SearchPagerView',
    'services/qualityManagementService',
    'services/loggingService',
    'services/tableConfigSettingsService',
    'util/errorCallbackFactory'
], function (_,
             ko,
             Promise,
             queuesService,
             ViewModel,
             ConversationDetailsView,
             SearchPagerView,
             qualityManagementService,
             loggingService,
             tableConfigSettingsService,
             errorCallbackFactory) {
    'use strict';

    var DEFAULT_TABLE_SETTINGS = {
        columns: [
            "agentName",
            "externalName",
            "startDateTime",
            "duration",
            "queue",
            "direction"
        ]
    };

    var TABLE_NAMESPACE = "INTERACTIONS_LIST_VIEW";
    /**
     * The InteractionsListView class.
     * @class
     */
    var InteractionsListView = ViewModel.extend(function (searchFiltersList, isSetupRequired, options) {
        var self = this;
        self.rowViews = ko.observableArray([]);
        self.loading = ko.observable(false);

        var tableNamespace = (options && options.tableNamespace) ? options.tableNamespace : TABLE_NAMESPACE;
        self.isSettingUp = ko.observable(isSetupRequired || false);
        self.isRefreshing = ko.observable(false);

        var pageState = ko.observable();
        var settingsLoaded = ko.observable(false),
            localTableSettings;

        self.searchPagerView = self.subView(SearchPagerView, pageState);
        self.visibleColumns = ko.observableArray(DEFAULT_TABLE_SETTINGS.columns);

        //
        // Load/Save Table Settings
        //

        localTableSettings = self.computed(function() {
            return {
                columns: self.visibleColumns()
            };
        });

        tableConfigSettingsService.getSettings(tableNamespace, _.clone(DEFAULT_TABLE_SETTINGS))
            .then(function (settings) {
                self.visibleColumns(settings.columns);
            })
            .catch(function (e) {
                loggingService.warn("Unable to retrieve the user's table preferences.", e);
            })
            .finally(function () {
                settingsLoaded(true);
            });

        localTableSettings.subscribe(function(updatedSettings) {
            if(settingsLoaded()){
                tableConfigSettingsService.setSettings(tableNamespace, updatedSettings)
                .catch(function (e) {
                    loggingService.warn("Failed to set the user's table preferences.", e);
                });
            }
        });

        var gridRowsFromConversations = function (conversations, extraData) {
            var opts = { expandUser: false };
            if (extraData) {
                _.merge(opts, extraData);
            }
            var newRowViews = [], row;
            _.forEach(conversations, function (interaction) {
                row = self.subView(ConversationDetailsView, interaction, opts);
                row.updateDuration();
                newRowViews.push(row);
            });
            self.rowViews.removeAll();
            self.rowViews.push.apply(self.rowViews, newRowViews);
        };

        var getPageAnchor = function () {
            return self.searchPagerView.pageAnchor();
        };

        var getPageSize = function () {
            return self.searchPagerView.rowOptionSelection();
        };

        var pendingRequest = null;
        self.refreshGrid = function () {
            if (pendingRequest) {
                pendingRequest.cancel();
                pendingRequest = null;
            }

            var queryOptions = {
                pageSize: getPageSize(),
                filters: ko.toJS(searchFiltersList)
            };

            self.loading(true);
            pendingRequest = qualityManagementService.getConversationSummary(queryOptions, getPageAnchor())
            .then(function (response) {
                pageState(response);

                if (response && response.entities && response.entities()) {
                    gridRowsFromConversations(response.entities());
                }
            })
            .catch(Promise.CancellationError, _.noop)
            .catch(function (e) {
                self.rowViews.removeAll();
                errorCallbackFactory.createCallback({
                    namespace: "interactionsList.conversationSummaryRequest"
                })(e);
            })
            .finally(function () {
                self.loading(false);
                pendingRequest = null;
            });
        };

        if (ko.isObservable(searchFiltersList)) {
            self.subscribe(searchFiltersList, function () {
                // If the filter list changes, reset to page 1
                pageState(null);
            });
        }

        self.resetTable = function () {

            // reset column config
            tableConfigSettingsService.clearSettings(tableNamespace)
                .catch(function (e) {
                    loggingService.warn("Failed to reset the user's table preferences.", e);
                })
                .finally(function () {
                    self.visibleColumns(DEFAULT_TABLE_SETTINGS.columns);
                });

        };

        self.computed(function () {
            if (!self.isSettingUp()) {
                ko.unwrap(self.searchPagerView.pageUri);
                ko.unwrap(self.searchPagerView.rowOptionSelection);
                ko.unwrap(searchFiltersList);
                self.refreshGrid();
            }
        });
    });

    return InteractionsListView;
});

